import { RATE_GROUP_ORDER } from '../../../../backend/src/utils/hourlyRateCatalog';
import type { RateView } from '@/types/product';

export { RATE_GROUP_ORDER };
export const rateGroup = (rate: Pick<RateView, 'key' | 'group'>) =>
  rate.group?.trim() ||
  (/^tarief_\d+$/.test(rate.key) ? 'Bestaande tarieven' : 'Overige uurtarieven');

export interface RateGroup {
  name: string;
  rates: RateView[];
}
export function groupRates(rates: RateView[], search = ''): RateGroup[] {
  const query = search.trim().toLocaleLowerCase('nl');
  const groups = new Map<string, RateView[]>();
  for (const rate of rates) {
    const group = rateGroup(rate);
    if (query && !`${group} ${rate.name}`.toLocaleLowerCase('nl').includes(query)) continue;
    groups.set(group, [...(groups.get(group) ?? []), rate]);
  }
  const position = (name: string) => {
    const index = RATE_GROUP_ORDER.indexOf(name);
    return index >= 0
      ? index
      : name === 'Bestaande tarieven'
        ? RATE_GROUP_ORDER.length + 1
        : RATE_GROUP_ORDER.length;
  };
  return [...groups]
    .sort(([a], [b]) => position(a) - position(b) || a.localeCompare(b, 'nl'))
    .map(([name, items]) => ({
      name,
      rates: [...items].sort(
        (a, b) =>
          (a.sortOrder ?? Number.MAX_SAFE_INTEGER) - (b.sortOrder ?? Number.MAX_SAFE_INTEGER) ||
          a.name.localeCompare(b.name, 'nl')
      ),
    }));
}
